import api from "./api";

const ContractorService = {
  //  GET all contractors
  getAll: async () => {
    const response = await api.get("/contractors/getAll");
    return response.data;
  },
  
  getActivePaginated: async (page = 1, limit = 20) => {
    const response = await api.get(`/contractors/getActive/paginated?page=${page}&limit=${limit}`);
    return response.data; // { data: [...], total: xx }
  },

  //  GET only active contractors
  getActive: async () => {
    const response = await api.get("/contractors/getActive/list");
    return response.data;
  },

  //  GET contractor by ID
  getById: async (id) => {
    const response = await api.get(`/contractors/getById/${id}`);
    return response.data;
  },

  // CREATE new contractor
  create: async (data) => {
    const response = await api.post("/contractors/save", data);
    return response.data;
  },

  // UPDATE contractor
  update: async (id, data) => {
    const response = await api.put(`/contractors/update/${id}`, data);
    return response.data;
  },

  // DELETE contractor
  remove: async (id) => {
    const response = await api.delete(`/contractors/${id}`);
    return response.data;
  },

  updateStatus: async (id, data) => {
  const response = await api.put(`/contractors/updateStatus/${id}`, data);
  return response.data;
  },

  getByCompanyId: async (companyId) => {
    const response = await api.get(`/contractors/getByCompany/${companyId}`);
    return response.data;
  },
  
};

export default ContractorService;
